export const sampleResume = `name = "Will Latin"
phone = "0450777777"
email = "fake@gmail.com"
address = '''
10 Some Street, Melbourne 3000
Australia'''
website = "https://www.wasab.ai"
profession = "Software Engineer"

github = "melbourne2991"

summary = '''
Passionate software developer, I thrive on solving challenging problems and learning new skills'''

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''

points = [
  "I was really good at being an amazing person",
  '''
  PDFKit also supports gradient fills. Gradients can be used just like color fills, and are applied with the same methods (e.g. fillColor, or just fill). Before you can apply a gradient with these methods, however, you must create a gradient object.'''
]

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''
points = [
  "I was really good at being an amazing person",
  '''I was amazing
  and I still am'''
]

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''
points = [
  "I was really good at being an amazing person",
  '''I was amazing
  and I still am'''
]

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''
points = [
  "I was really good at being an amazing person",
  '''I was amazing
  and I still am'''
]

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''
points = [
  "I was really good at being an amazing person",
  '''I was amazing
  and I still am'''
]

[[employment]]
organization = "Some company"
title = "Software Engineer"
started = "2015-02-12"
finished = "2015-02-12"
description = '''
Lines are packed toward the start of the flex container. The cross-start edge of the first line in the flex container is placed flush with the cross-start edge of the flex container, and each subsequent line is placed flush with the preceding line. Lines are packed toward the end of the flex container.'''
points = [
  "I was really good at being an amazing person",
  '''I was amazing
  and I still am'''
]

[[education]]
qualification = "Bachelor of Science"
institution = "Fakefake College"
started = "April 2010"
finished = "June 2013"

[[education]]
qualification = "Bachelor of Arts"
institution = "Fakefake College"
started = "March 2013"
finished = "January 2018"`;
